import MainMenu from 'components/mainMenu/MainMenu';
import Components from '../index';
import _ from 'underscore';
import jQuery from 'jquery';

export default MainMenu.extend({
	template: require('./mainMenu.hbs'),

	constructor(options) {
        this.activeMobile = false;
		this.componentClass = options.componentClass;
		MainMenu.prototype.constructor.call(this, options);
	},

	initialize(options) {
		if (this.widget.isMobileVersion) {
			this.componentClass += '-mobile-version';
		}
		MainMenu.prototype.initialize.call(this, options);
		this.templateConfig.meliaMobileVersionClass = 'melia-mobile-version';
		this.addMainMenuListeners();
	},

	addMainMenuListeners() {
		this.listenTo(
			this.widget.bus,
			'directions_btn_event',
			(active, hotelData) => {
				if (active) {
					this.hideMainBlock();
					this.showDirectionsBox();
					if (hotelData) {
						this.components.DirectionsBox.fillOriginWithHotel(hotelData);
					}
					if (this.widget.isMobileVersion && !this.activeMobile) {
                        this.activeMobile = !this.activeMobile;
						this.containerToFullWidth();
					}
				} else {
					this.hideDirectionsBox();
					this.components.DirectionsBox.close();
					this.hideDetailsPanel();
					this.showMainBlock();
					if (this.widget.isMobileVersion && this.activeMobile) {
                        this.activeMobile = !this.activeMobile;
						this.containerToFullWidth();
					}
				}
			}
		);

		this.listenTo(this.widget.bus, 'CLICK_IN_DETAILS_ROUTE_BTN', routeData => {
			this.components.JPRouteDetails.updateRouteDetails(
				routeData.route,
				routeData.origin,
				routeData.destination,
				routeData.travelMode,
				routeData.originIsMainHotel,
				routeData.panelCollapsed
			);
			this.hideDirectionsBox();
			this.showDetailsPanel();
		});

		this.listenTo(this.widget.bus, 'CLICK_IN_BACK_DETAILS_ROUTE', () => {
			this.showDirectionsBox();
			this.hideDetailsPanel();
		});
	},

	_createSubComponents(components) {
		let availableComponents = _.filter(components, (component, key) => {
			if (component) {
				component.identifier = key;
				return true;
			} else {
				return false;
			}
		});

		let sortedComponens = _.sortBy(availableComponents, 'order');
		_.each(sortedComponens, component => {
			if (_.isObject(Components[component.componentConstructorClass])) {
				let _component = (this.components[
					component.identifier
				] = new Components[component.componentConstructorClass](
					_.extend({}, component, {
						map: this.map,
						widget: this.widget,
						isChild: true,
						properties: component.properties || {}
					})
				));
				this.append(_component.el, _component.position);
			}
		});
	},

	showMainBlock() {
		this.$el.find('.melia-main-menu-class-main-box-container').show();
	},

	hideMainBlock() {
		this.$el.find('.melia-main-menu-class-main-box-container').hide();
		this.components.MainBox.hide();
	},

	showDirectionsBox() {
		this.$el.find('.melia-main-menu-class-directions-box-container').show();
		this.components.DirectionsBox.open();
	},

	hideDirectionsBox() {
		this.$el.find('.melia-main-menu-class-directions-box-container').hide();
	},

	showDetailsPanel() {
		this.$el.find('.melia-main-menu-class-route-details-container').show();
	},

	hideDetailsPanel() {
		this.$el.find('.melia-main-menu-class-route-details-container').hide();
	},

	containerToFullWidth() {
		jQuery(this.el).toggleClass('melia-mobile-full-width');
	},

	containerToRegularWidth() {
		jQuery(this.el).removeClass('melia-mobile-full-width');
	},
});



// WEBPACK FOOTER //
// ./src/components/meliaMainMenu/MeliaMainMenu.js